<div id="cesiumContainer"></div>
<div id="cesiumCreditViewport" style="position: absolute; height: 0; visibility: hidden"></div>
<div id="cesiumCreditContainer" style="position: absolute; height: 0; visibility: hidden"></div>
